/**
 * Workspace and country for Voluum lander (General tab).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Input } from '@/components/ui/form/input/Input';

import type { VoluumLanderFormValues } from '../map-voluum-lander-form';

const labelCls = 'text-xs font-semibold text-muted-foreground';
const fieldCls = 'space-y-1';

export interface LanderMetaFieldsProps {
  values: VoluumLanderFormValues;
  patch: (p: Partial<VoluumLanderFormValues>) => void;
  disabled?: boolean;
}

const LanderMetaFields: FC<LanderMetaFieldsProps> = ({
  values,
  patch,
  disabled,
}) => (
  <div className="space-y-3 text-sm">
    <div className={fieldCls}>
      <label className={labelCls} htmlFor="lander-workspace">
        Workspace ID (UUID)
      </label>
      <Input
        id="lander-workspace"
        value={values.workspaceId}
        disabled={disabled}
        onChange={(e) => patch({ workspaceId: e.target.value })}
        className="h-8 font-mono text-xs"
      />
    </div>
    <div className={fieldCls}>
      <label className={labelCls} htmlFor="lander-country">
        Country code (optional)
      </label>
      <Input
        id="lander-country"
        value={values.countryCode}
        disabled={disabled}
        onChange={(e) => patch({ countryCode: e.target.value })}
        placeholder="e.g. FR"
        className="h-8 w-24 uppercase"
      />
    </div>
  </div>
);

export default LanderMetaFields;
